import React from "react";
import userData from "../../userdata.json"
function SideNav({ isVisible = false ,handleIsVsible}) {
    const handleClick=(event)=>{
        const fieldData=event?.currentTarget?.dataset?.val;
        window.location.href=`#${fieldData}`;
        console.log(fieldData)
        handleIsVsible();
      }
    const {navtabs}=userData||{}
  return (
    <>
      {isVisible ? (
        <div
          className={` overlay bottom-0 fixed left-0 right-0 top-0 z-999 transition-all-1 `}
          onClick={handleIsVsible}
        />
      ) : null}
        <div className={`dn-l w-50 glassmorphic-nav z-9999 fixed right-0 top-0 h-100 transition-all-1 ${isVisible?"tranlate-0":"tranlate-100"}`}>
          <div className="flex flex-column items-center pv6">
            {
                (navtabs||[]).map((tab,index)=>(
                    <div  data-val={tab} onClick={handleClick} className="primary no-underline pv3">
                        {tab}
                    </div>
                ))
            }
          </div>
        </div>
    </>
  );
}

export default SideNav;
